import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "columns is-centered" }
const _hoisted_3 = { class: "columns is-12" }
const _hoisted_4 = { class: "is-grey-background" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-centered" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "column is-12",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "title is-narrow is-spaced" }, "Change Password")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-centered" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column is-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-centered" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column padding-left-3 padding-right-3" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "Password Requirements"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, " 1. Be a minimum length of eight (8) characters. "),
      /*#__PURE__*/_createElementVNode("li", null, " 2. Can not be the same as your username "),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" 3. The password must contain at least 1 character from a minimum of 3 of the following 4 categories: "),
        /*#__PURE__*/_createElementVNode("ul", { style: {"padding-left":"25px"} }, [
          /*#__PURE__*/_createElementVNode("li", null, "1) Upper Case"),
          /*#__PURE__*/_createElementVNode("li", null, "2) Lower Case"),
          /*#__PURE__*/_createElementVNode("li", null, "3) Number"),
          /*#__PURE__*/_createElementVNode("li", null, "4) Symbol")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-centered" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column is-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_9 = { class: "columns is-centered" }
const _hoisted_10 = { class: "column is-6" }
const _hoisted_11 = { class: "columns is-centered" }
const _hoisted_12 = { class: "column is-6" }
const _hoisted_13 = { class: "columns is-centered" }
const _hoisted_14 = { class: "column is-narrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_o_loading, {
      active: _ctx.isPageLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isPageLoading) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_icon, {
          pack: "fa",
          icon: "spinner",
          size: "large",
          spin: "",
          variant: "primary"
        })
      ]),
      _: 1
    }, 8, ["active"]),
    (_ctx.displayChangePassword)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          ref: "formValidator",
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Field, {
                        name: "Password",
                        modelValue: _ctx.form.Password,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Password) = $event)),
                        ref: "passwordInput"
                      }, {
                        default: _withCtx(({ field, meta, errors }) => [
                          _createVNode(_component_o_field, {
                            label: "New Password",
                            variant: errors[0] ? 'danger' : '',
                            message: errors[0] ? errors[0] : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_o_input, _mergeProps({
                                placeholder: "New Password",
                                modelValue: _ctx.form.Password,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Password) = $event))
                              }, field, {
                                onInput: _ctx.validatePassword,
                                type: "password",
                                "password-reveal": ""
                              }), null, 16, ["modelValue", "onInput"])
                            ]),
                            _: 2
                          }, 1032, ["variant", "message"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        name: "ConfirmPassword",
                        modelValue: _ctx.ConfirmPassword,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ConfirmPassword) = $event))
                      }, {
                        default: _withCtx(({ field, meta, errors }) => [
                          _createVNode(_component_o_field, {
                            label: "Confirm Password",
                            variant: errors[0] ? 'danger' : '',
                            message: errors[0] ? errors[0] : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_o_input, _mergeProps({
                                placeholder: "Confirm Password",
                                modelValue: _ctx.ConfirmPassword,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ConfirmPassword) = $event))
                              }, field, {
                                type: "password",
                                "password-reveal": ""
                              }), null, 16, ["modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["variant", "message"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_o_button, {
                        variant: "info",
                        class: "is-fullwidth-mobile",
                        pack: "fas",
                        "icon-left": "search",
                        "native-type": "submit"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Submit ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]))
      : _createCommentVNode("", true)
  ]))
}